import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { webrtcCheck } from "@forproxyband/react-tools";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useClientSelectors, useWebRtcStatus } from "../../../hooks";

import { Container, WidgetTable } from "../../../components";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Seo } from "../../../components/Seo/Seo";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import { WidgetStatus } from "../../../components/common/WidgetStatus/WidgetStatus";
import { IpsTable } from "./components/IpsTable/IpsTable";

import { Section } from "../../../components/common/Section/Section.styled";
import { GridItem, Wrapper } from "./CheckWebRtc.styled";

const CheckWebrtc = () => {
  const [ips, setIps] = useState([]);

  const [showLoader, setShowLoader] = useState(true);

  const { t } = useTranslation();
  const { info } = useClientSelectors();

  const webRtcStatus = useWebRtcStatus(ips, info?.ip, setIps);

  useEffect(() => {
    (async () => {
      if (info?.ip) {
        webrtcCheck.check(setIps);
      }
    })();
  }, [info?.ip]);

  const handleFinish = () => {
    setShowLoader(false);
  };

  const restartTest = () => {
    window.location.reload();
  };

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          <Wrapper>
            {showLoader ? (
              <LoadingSpinner onFinish={handleFinish} />
            ) : (
              <GridItem>
                <WidgetTable
                  button={t("webrtcCheck.runWebRtcCheck")}
                  backData={info}
                  onButtonClick={restartTest}
                  params="none"
                >
                  <IpsTable
                    ips={ips}
                    webRtcStatus={webRtcStatus}
                    userIp={info?.ip}
                  />
                </WidgetTable>
              </GridItem>
            )}

            {showLoader ? (
              <WidgetStatus />
            ) : (
              <WidgetStatus
                status={webRtcStatus ? "error" : "success"}
                title={
                  webRtcStatus
                    ? t("webrtcCheck.notProtect")
                    : t("webrtcCheck.protected")
                }
                description={
                  webRtcStatus
                    ? t("webrtcCheck.notProtectedDescription")
                    : t("webrtcCheck.protectedDescription")
                }
              />
            )}
          </Wrapper>
        </Container>
      </Section>

      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

CheckWebrtc.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default CheckWebrtc;
